import { useUser } from 'features/auth';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useUpdateUserProfile } from 'features/users/queries/mutations/useUpdateUserProfile';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useGenders } from 'features/users/queries/useGenders';
import { PersonalInfoForm, type PersonalInfoFormValues } from './personal-info-form';
import { PersonalInfoSkeleton } from './personal-info-skeleton';

type P = {
  initialFormValues?: Partial<PersonalInfoFormValues>;
  onBack: (formValues: Partial<PersonalInfoFormValues>) => void;
  onSuccess: () => void;
};

const PersonalInfoContent = ({ initialFormValues, onBack, onSuccess }: P) => {
  const { data: genders, isLoading: isLoadingGenders } = useGenders();
  const { isPending: isUpdatingProfile, mutate: updateProfile } = useUpdateUserProfile();
  const { railsUserData } = useUser();

  const onSubmit = (values: PersonalInfoFormValues) => {
    updateProfile(
      {
        userData: values,
        userId: railsUserData.id,
      },
      {
        onSuccess,
      },
    );
  };

  if (isLoadingGenders || !genders) {
    return <PersonalInfoSkeleton />;
  }

  return (
    <PersonalInfoForm
      genders={genders}
      initialFormValues={initialFormValues}
      isLoading={isUpdatingProfile}
      onBack={onBack}
      onSubmit={onSubmit}
    />
  );
};

export default PersonalInfoContent;
